"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnEntityRemovedFromGroup = void 0;
/**
 * @public
 * Emitted on entity removed from group, if the entity is not present this is not emitted.
 */
class OnEntityRemovedFromGroup {
    constructor(onEntityRemovedFromGroup) {
        this.onEntityRemovedFromGroup = onEntityRemovedFromGroup;
    }
    static registerListener(plot, onEvent) {
        return plot.eventService
            .getCategory(OnEntityRemovedFromGroup)
            .addTemporaryListener(new OnEntityRemovedFromGroup(onEvent));
    }
    static registerOneTimeListener(plot, onEvent) {
        return plot.eventService
            .getCategory(OnEntityRemovedFromGroup)
            .addOneTimeListener(new OnEntityRemovedFromGroup(onEvent));
    }
    static emit(plot, entity, group) {
        const listeners = plot.eventService
            .getCategory(OnEntityRemovedFromGroup)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onEntityRemovedFromGroup(entity, group);
        }
    }
}
exports.OnEntityRemovedFromGroup = OnEntityRemovedFromGroup;
OnEntityRemovedFromGroup.callbackKey = "onEntityRemovedFromGroup";
//# sourceMappingURL=on-entity-removed-from-group.js.map